module.exports = __webpack_public_path__ + "img/teach-empty.7bc0a58b.svg";